export default __webpack_public_path__ + "assets/style_icon.svg";